import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { selectors as UsersSelectors } from 'data/users'

import CommentsEditor from 'components/Editors/CommentEditor'
import { UserAvatar } from 'components/Utils/Avatar'
import SendAndCancel from './Commands/SendAndCancel'
import NotificationAudienceHelper from './Commands/NotificationAudienceHelper'

import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'
import { getEntitiesRange } from 'components/Editors/CommentEditor/utils'

function CommentCreator({
  placeholder = null,
  threadSubscriberIds,
  startOfThread,
  replier,
  threadDraft,
  sendStatus,
  onChange,
  onSubmit,
}) {
  const containerRef = React.useRef(null)
  const commentEditorRef = React.useRef(null)

  const currentUserId = useSelector(UsersSelectors.getCurrentUserId)

  const [editorIsActive, setEditorIsActive] = React.useState(false)
  const [mentionIds, setMentionIds] = React.useState([])

  function onCommentChange(content, editorValue) {
    setEditorIsActive(content && content.length > 0)
    onChange(editorValue.toJSON())

    const entities = getEntitiesRange(editorValue)
    const mentionIds = entities
      .filter(e => !!e.data.userId)
      .map(e => e.data.userId)
    setMentionIds(mentionIds)
  }

  function onCommentSubmit(content, entities) {
    // Prevent empty lines at the end
    const trimmedContent = content.replace(/\s+$/g, '')
    onSubmit(trimmedContent, entities)
    setEditorIsActive(false)
  }

  function onCancel() {
    commentEditorRef.current.resetInput()
    setEditorIsActive(false)
  }

  return (
    <div className="flexbox padding-vertical-normal padding-horizontal-large">
      <div className="margin-right-small padding-top-small">
        <UserAvatar size="base" userId={currentUserId} noBorder />
      </div>
      <div className="flexbox-grow">
        <div
          ref={containerRef}
          className="background-shade-50 radius-large"
          style={{
            cursor: 'text',
          }}
        >
          <CommentsEditor
            autoFocus
            ref={commentEditorRef}
            placeholder={placeholder}
            replier={replier}
            onSubmit={onCommentSubmit}
            onChange={onCommentChange}
            onCancel={onCancel}
            threadDraft={threadDraft}
            readOnly={false}
            editorClassName={classNames(
              'global-comment-editor line-height-larger'
            )}
            containerClassName={classNames('padding-normal', {
              active: editorIsActive,
            })}
            commentCreator
            sendStatus={sendStatus}
          />
        </div>

        <div
          className="flexbox flexbox-align-center transition"
          style={{
            opacity: editorIsActive ? 1 : 0,
            height: 40 + 12,
          }}
        >
          {editorIsActive && (
            <div className="width-full flexbox flexbox-align-center margin-top-normal">
              <NotificationAudienceHelper
                mentionIds={mentionIds}
                threadSubscriberIds={threadSubscriberIds}
                startOfThread={startOfThread}
              />
              <div className="flexbox-no-shrink margin-left-small">
                <SendAndCancel
                  onSubmit={() => {
                    commentEditorRef.current.submit()
                  }}
                  onCancel={onCancel}
                  hideCancel={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default withNoteMetaPanelControls(CommentCreator)
